<template>
    <div class="unprintable">
        <b-form>
            <div class="row" v-for="(protege, index) in proteges" :key="protege.id" v-if="isNewRow(index)">
                <div class="col-12 col-sm-6">
                    <guardian-component :firstname="protege.profile.firstname"
                                        :lastname="protege.profile.lastname"
                                        :address="protege.profile.address"
                                        :extraAddressLine="protege.profile.extraAddressLine"
                                        :zipcode="protege.profile.zipcode"
                                        :city="protege.profile.city"
                                        :email="protege.profile.email"
                                        :mobile="protege.profile.mobile"
                                        :phone="protege.profile.phone"
                                        :website="protege.profile.website">
                    </guardian-component>
                    <div class="row">
                        <div class="col">
                            <div class="gapper">
                                {{ $t('photos.title') }}
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col">
                            <div v-for="photos in chunkedPhotos(proteges[index].documents.photos)" :key="photos.id">
                                <div class="row">
                                    <div v-for="photo in photos" :key="photo.id" class="col-3">
                                        <a href="javascript:void(0)">
                                            <img fluid :src="photo.oURL" :id="photo.name" class="thumbnail"
                                                 @click="showModal(photo.id)">
                                        </a>
                                        <b-modal :id="getValidID(photo.id)" :ref="getValidID(photo.id)"
                                                 :title="photo.name" size="lg" :hide-footer=true>
                                            <b-img fluid :src="photo.oURL" :id="photo.name"></b-img>
                                            <div class="spacer"></div>
                                        </b-modal>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col">
                            <div class="gapper">
                                {{ $t('videos.title') }}
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col general-docs-item">
                            <div v-for="video in proteges[index].documents.videos" :key="video.id">
                                <a href="javascript:void(0)" v-on:click="downloadVideo(proteges[index].profile.id, video.id, video.name, index)">
                                    <icon name="film"></icon>
                                    {{video.name}}
                                </a>
                            </div>
                        </div>
                    </div>
                    <div class="row video-player-container" v-bind:class="{ 'player-is-not-shown': videoNotLoaded(index) }">
                        <div class="col">
                            <div class="embed-responsive embed-responsive-1by1">
                                <video controls :id="'video-player' + index" muted="true">
                                <!--<video controls id="video-player" muted="true">-->
                                    <source src="">
                                    Your browser does not support the video tag.
                                </video>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col">
                            <div class="gapper">
                                {{ $t('documents.generalDocs.title') }}
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col general-docs-item">
                            <div v-for="document in proteges[index].documents.generalDocs" :key="document.id">
                                <a href="javascript:void(0)" v-on:click="download(proteges[index].profile.id, document.id, document.name)">
                                    <icon name="file-o"></icon>
                                    {{document.name}}
                                </a>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col">
                            <div class="gapper">
                                {{ $t('speeches.allInfo.title')}}
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col download-link">
                            <a href="javascript:void(0)" v-on:click="downloadSpeech(protege.profile.id, deathNoticeType, protege.speeches.deathNoticeFile.name)"
                               v-if="protege.speeches.deathNoticeFile.url != null">
                                <icon name="file-o"></icon>
                                {{ $t('speeches.documents.obituaryText') }}
                            </a>
                        </div>
                        <div class="col download-link">
                            <a href="javascript:void(0)" v-on:click="downloadSpeech(protege.profile.id, burialSpeechType, protege.speeches.burialSpeechFile.name)"
                               v-if="protege.speeches.burialSpeechFile.url != null">
                                <icon name="file-o"></icon>
                                {{ $t('speeches.documents.funeralSpeechText') }}
                            </a>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col download-link">
                            <a href="javascript:void(0)" v-on:click="downloadSpeech(protege.profile.id, ceremonySpeechType, protege.speeches.ceremonySpeechFile.name)"
                               v-if="protege.speeches.ceremonySpeechFile.url != null">
                                <icon name="file-o"></icon>
                                {{ $t('speeches.documents.partySpeechText') }}
                            </a>
                        </div>
                        <div class="col download-link">
                        </div>
                    </div>
                    <div class="row delete-and-print-section">
                        <div class="col delete-protege-link">
                            <a href="javascript:void(0)" v-on:click="deleteProtege(protege.profile.id)">
                                <icon name="trash-o"></icon>
                                {{$t('proteges.deleteLink')}}
                            </a>
                        </div>
                        <div class="col print-link">
                            <protege-all-info-component :protege="protege"></protege-all-info-component>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-sm-6">
                    <guardian-component v-if="index < proteges.length-1"
                                        :firstname="proteges[index+1].profile.firstname"
                                        :lastname="proteges[index+1].profile.lastname"
                                        :address="proteges[index+1].profile.address"
                                        :extraAddressLine="proteges[index+1].profile.extraAddressLine"
                                        :zipcode="proteges[index+1].profile.zipcode"
                                        :city="proteges[index+1].profile.city"
                                        :email="proteges[index+1].profile.email"
                                        :mobile="proteges[index+1].profile.mobile"
                                        :phone="proteges[index+1].profile.phone"
                                        :website="proteges[index+1].profile.website">
                    </guardian-component>
                    <div class="row" v-if="index < proteges.length-1">
                        <div class="col">
                            <div class="gapper">
                                {{ $t('photos.title') }}
                            </div>
                        </div>
                    </div>
                    <div class="row" v-if="index < proteges.length-1">
                        <div class="col">
                            <div v-for="photos in chunkedPhotos(proteges[index+1].documents.photos)" :key="photos.id">
                                <div class="row">
                                    <div v-for="photo in photos" :key="photo.id" class="col-3">
                                        <a href="javascript:void(0)">
                                            <img fluid :src="photo.oURL" :id="photo.name" class="thumbnail"
                                                 @click="showModal(photo.id)">
                                        </a>
                                        <b-modal :id="getValidID(photo.id)" :ref="getValidID(photo.id)"
                                                 :title="photo.name" size="lg" :hide-footer=true>
                                            <b-img fluid :src="photo.oURL" :id="photo.name"></b-img>
                                            <div class="spacer"></div>
                                        </b-modal>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row" v-if="index < proteges.length-1">
                        <div class="col">
                            <div class="gapper">
                                {{ $t('videos.title') }}
                            </div>
                        </div>
                    </div>
                    <div class="row" v-if="index < proteges.length-1">
                        <div class="col general-docs-item">
                            <div v-for="video in proteges[index+1].documents.videos" :key="video.id">
                                <a href="javascript:void(0)" v-on:click="downloadVideo(proteges[index+1].profile.id, video.id, video.name, (index+1))">
                                    <icon name="film"></icon>
                                    {{video.name}}
                                </a>
                            </div>
                        </div>
                    </div>
                    <div class="row video-player-container" v-bind:class="{ 'player-is-not-shown': videoNotLoaded(index+1) }" v-if="index < proteges.length-1">
                        <div class="col">
                            <div class="embed-responsive embed-responsive-1by1">
                                <video controls :id="'video-player' + (index+1)" muted="true">
                                    <source src="">
                                    Your browser does not support the video tag.
                                </video>
                            </div>
                        </div>
                    </div>

                    <div class="row" v-if="index < proteges.length-1">
                        <div class="col">
                            <div class="gapper">
                                {{ $t('documents.generalDocs.title') }}
                            </div>
                        </div>
                    </div>
                    <div class="row" v-if="index < proteges.length-1">
                        <div class="col general-docs-item">
                            <div v-for="document in proteges[index+1].documents.generalDocs" :key="document.id">
                                <a href="javascript:void(0)" v-on:click="download(proteges[index+1].profile.id, document.id, document.name)">
                                    <icon name="file-o"></icon>
                                    {{document.name}}
                                </a>
                            </div>
                        </div>
                    </div>

                    <div class="row" v-if="index < proteges.length-1">
                        <div class="col">
                            <div class="gapper">
                                {{ $t('speeches.allInfo.title')}}
                            </div>
                        </div>
                    </div>
                    <div class="row" v-if="index < proteges.length-1">
                        <div class="col download-link">
                            <a href="javascript:void(0)"
                               v-on:click="downloadSpeech(proteges[index+1].profile.id, deathNoticeType, proteges[index+1].speeches.deathNoticeFile.name)"
                               v-if="proteges[index+1].speeches.deathNoticeFile.url != null">
                                <icon name="file-o"></icon>
                                {{ $t('speeches.documents.obituaryText') }}
                            </a>
                        </div>
                        <div class="col download-link">
                            <a href="javascript:void(0)"
                               v-on:click="downloadSpeech(proteges[index+1].profile.id, burialSpeechType, proteges[index+1].speeches.burialSpeechFile.name)"
                               v-if="proteges[index+1].speeches.burialSpeechFile.url != null">
                                <icon name="file-o"></icon>
                                {{ $t('speeches.documents.funeralSpeechText') }}
                            </a>
                        </div>
                    </div>
                    <div class="row" v-if="index < proteges.length-1">
                        <div class="col download-link">
                            <a href="javascript:void(0)"
                               v-on:click="downloadSpeech(proteges[index+1].profile.id, ceremonySpeechType, proteges[index+1].speeches.ceremonySpeechFile.name)"
                               v-if="proteges[index+1].speeches.ceremonySpeechFile.url != null">
                                <icon name="file-o"></icon>
                                {{ $t('speeches.documents.partySpeechText') }}
                            </a>
                        </div>
                        <div class="col download-link">
                        </div>
                    </div>

                    <div class="row delete-and-print-section" v-if="index < proteges.length-1">

                        <div class="col delete-protege-link">
                            <a href="javascript:void(0)" v-on:click="deleteProtege(proteges[index+1].profile.id)">
                                <icon name="trash-o"></icon>
                                {{$t('proteges.deleteLink')}}
                            </a>
                        </div>
                        <div class="col print-link">
                            <protege-all-info-component :protege="proteges[index+1]"></protege-all-info-component>
                        </div>

                    </div>
                </div>
            </div>
        </b-form>
    </div>
</template>

<script>
    import {mapActions, mapGetters} from 'vuex'
    import {
        PROTEGES_ACTION_DELETE_PROTEGE,
        PROTEGES_ACTION_GET_PROTEGES,
        PROTEGES_GETTER,
        PROTEGES_NAMESPACE
    } from '../../store/modules/proteges-types'
    import {
        SPEECHES_TYPE_BURIAL_SPEECH,
        SPEECHES_TYPE_CEREMONY_SPEECH,
        SPEECHES_TYPE_DEATH_NOTICE
    } from '../../store/modules/speeches-types'
    import GuardianComponent from './GuardianComponent'
    import ProtegeAllInfoComponent from './ProtegeAllInfoComponent'
    import 'vue-awesome/icons/trash-o'
    import Icon from 'vue-awesome/components/Icon'
    import API from '../../services/API'
    import i18n from '../../assets/i18n/lang'
    import chunk from 'chunk'
    const { detect } = require('detect-browser')

    export default {
        name: 'Proteges',
        metaInfo () { return {title: i18n.t('proteges.meta')} },
        components: {
            'guardian-component': GuardianComponent,
            'protege-all-info-component': ProtegeAllInfoComponent,
            'icon': Icon
        },
        data: function () {
            return {
                burialSpeechType: SPEECHES_TYPE_BURIAL_SPEECH,
                ceremonySpeechType: SPEECHES_TYPE_CEREMONY_SPEECH,
                deathNoticeType: SPEECHES_TYPE_DEATH_NOTICE,
                currentID: 3,
                videoPlayerShown: []
                // videoNotLoaded: true
            }
        },
        computed: {
            ...mapGetters(PROTEGES_NAMESPACE, {
                proteges: PROTEGES_GETTER
            })
        },
        methods: {
            ...mapActions(PROTEGES_NAMESPACE, {
                loadProteges: PROTEGES_ACTION_GET_PROTEGES,
                deleteProtege: PROTEGES_ACTION_DELETE_PROTEGE
            }),
            isNewRow: function (index) {
                if (index % 2 === 0) return true
                else return false
            },
            download (protegeId, docId, docName) {
                API.downloadProtegeGenDocFromBackend(protegeId, docId)
                    .then((data) => {
                        return this.insertDownloadlink(data, docName)
                    })
                    .catch((error) => console.log(error.message))
            },
            downloadVideo (protegeId, videoId, videoName, index) {
                API.downloadProtegeVideoFromBackend(protegeId, videoId)
                    .then((data) => {
                        const browser = detect()
                        if (browser.os === 'iOS') {
                            return this.playVideo(data, videoName, index)
                        } else {
                            return this.insertDownloadlink(data, videoName)
                        }
                    })
                    .catch((error) => console.log('error: ' + error.message))
            },
            playVideo (data, docName, index) {
                return new Promise(
                    (resolve, reject) => {
                        window.URL = window.URL || window.webkitURL
                        var video = document.getElementById('video-player' + index)
                        video.src = window.URL.createObjectURL(new Blob([data], {type: data.type}))
                        video.load()
                        this.videoPlayerShown.push(index)
                        resolve()
                    }
                )
            },
            downloadSpeech (id, documentType, docName) {
                API.downloadFileFromBackend(id, documentType)
                    .then((data) => {
                        return this.insertDownloadlink(data, docName)
                    })
                    .catch((error) => console.log(error.message))
            },
            insertDownloadlink (data, docName) {
                return new Promise(
                    (resolve, reject) => {
                        const link = document.createElement('a')
                        link.href = window.URL.createObjectURL(new Blob([data]))
                        link.setAttribute('download', docName)
                        document.body.appendChild(link)
                        link.click()
                        document.body.removeChild(link)
                        resolve()
                    }
                )
            },
            zack: function (newID) {
                this.currentID = newID
            },
            chunkedPhotos (photos) {
                if (photos !== 'undefined') {
                    return chunk(photos, 4)
                } else {
                    return []
                }
            },
            getValidID (id) {
                return 'id' + id
            },
            showModal (id) {
                this.$root.$emit('bv::show::modal', this.getValidID(id))
            },
            videoNotLoaded (index) {
                return !this.videoPlayerShown.includes(index)
            }
        },
        created () {
            this.loadProteges()
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../assets/scss/custom/vars';

    .add-protege-link {
        text-align: right;
        text-decoration: underline;
    }

    .delete-protege-link {
        text-align: left;
        text-decoration: underline;
    }

    .print-link {
        text-align: right;
        text-decoration: underline;
    }

    .download-link {
        text-align: left;
        text-decoration: underline;
    }

    .delete-and-print-section {
        padding-top: 15px;
    }

    .thumbnail {
        object-fit: cover;
        max-width: 100%;
        max-height: 100%;
    }

    .general-docs-item {
        text-align: left;
    }

    .gapper {
        text-align: left;
        border-bottom: 2px solid $omyfu-red;
        margin-bottom: 20px;
        padding-top: 40px;
    }

    @media print {
        .unprintable {
            visibility: hidden;
            display: none;
        }
    }

    .video-player-container {
        padding-top: 20px;
    }

    .player-is-not-shown {
        display: none;
    }
</style>



// WEBPACK FOOTER //
// src/components/guardian/ProtegesComponent.vue